import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import { ModalAllder } from "layouts/ModalAllder";
import { NumericFormat } from "react-number-format";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, DragOverlay, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import Productrow from "layouts/Productrow";
import { getEmpFullNameTHByEmpData, NumberFormat, setProductRowVatByMstCategoryPrice } from "utils/HelperFunction";
import moment from "moment";
import { getDeliveredStatusList, getDocTableRowPesInit, removeCheckedProductsAndSyncSelections } from "utils/HelperPesFunction";
import { columnPresets } from "hooks/product/columnPresets";
import TagSelected from "fragments/TagSelected";
import PesFooterSubmit from "layouts/PesFooterSubmit";
import PesModalGroup from "layouts/PesModalGroup";
import { ProductTableFilterDisplay } from "layouts/ProductTableFilterDisplay";
import usePesLoadingSync from "hooks/pes/usePesLoadingSync";
import { PesMultiSelectTable } from "layouts/PesMultiSelectTable";
import DocTableRow from "./DocTableRow";
import { usePesInitContext } from "contexts/purhaseExpenseSyncPage/pesInitContext";
import PesDocStatus from "./PesDocStatus";
import { ProductTableSort } from "./ProductTableSort";
export function PesContent() {
    var pesID = useParams().pesID;
    var _usePesInitContext = usePesInitContext(), pesModalInitState = _usePesInitContext.pesModalInitState, pesFormState = _usePesInitContext.pesFormState, tab = _usePesInitContext.tab, setTab = _usePesInitContext.setTab, tagselected = _usePesInitContext.tagselected, setTagSelected = _usePesInitContext.setTagSelected, attachments = _usePesInitContext.attachments, isInitPesLoading = _usePesInitContext.isInitPesLoading, options = _usePesInitContext.options, productRow = _usePesInitContext.productRow, setProductRow = _usePesInitContext.setProductRow, sumproductPrice = _usePesInitContext.sumproductPrice, setSumproductPrice = _usePesInitContext.setSumproductPrice, sumproductNoVat = _usePesInitContext.sumproductNoVat, setSumproductNoVat = _usePesInitContext.setSumproductNoVat, sumproductZeroVat = _usePesInitContext.sumproductZeroVat, setSumproductZeroVat = _usePesInitContext.setSumproductZeroVat, sumproductSevenVat = _usePesInitContext.sumproductSevenVat, setSumproductSevenVat = _usePesInitContext.setSumproductSevenVat, sumproductBeforeVat = _usePesInitContext.sumproductBeforeVat, setSumproductBeforeVat = _usePesInitContext.setSumproductBeforeVat, sumproductOrdered = _usePesInitContext.sumproductOrdered, setSumproductOrdered = _usePesInitContext.setSumproductOrdered, updateDocIds = _usePesInitContext.updateDocIds, columnsort = _usePesInitContext.columnsort, setColumnsort = _usePesInitContext.setColumnsort, filterDisplay = _usePesInitContext.filterDisplay, setFilterDisplay = _usePesInitContext.setFilterDisplay;
    var _useState = _sliced_to_array(useState([]), 2), attachmentDeliver = _useState[0], setAttachmentDeliver = _useState[1];
    var handlePreviewDeliverFile = function(e) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachmentDeliver(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var _useState1 = _sliced_to_array(useState(true), 2), Collapse = _useState1[0], setCollapse = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), inputMemberValue = _useState2[0], setInputMemberValue = _useState2[1];
    var modalConfirmCancel = pesModalInitState.modalConfirmCancel, setModalConfirmCancel = pesModalInitState.setModalConfirmCancel, modalSuccess = pesModalInitState.modalSuccess, setModalSuccess = pesModalInitState.setModalSuccess, modalSaveSuccess = pesModalInitState.modalSaveSuccess, setModalSaveSuccess = pesModalInitState.setModalSaveSuccess, modalDeliEndProcess = pesModalInitState.modalDeliEndProcess, setModalDeliEndProcess = pesModalInitState.setModalDeliEndProcess, modalNotApprove = pesModalInitState.modalNotApprove, setModalNotApprove = pesModalInitState.setModalNotApprove, modalAlert = pesModalInitState.modalAlert, setModalAlert = pesModalInitState.setModalAlert, modalReadyToDeliProcess = pesModalInitState.modalReadyToDeliProcess, setModalReadyToDeliProcess = pesModalInitState.setModalReadyToDeliProcess;
    var schema = pesFormState.schema, formdisabled = pesFormState.formdisabled, setFormdisabled = pesFormState.setFormdisabled, setPdata = pesFormState.setPdata, formdata = pesFormState.formdata, setFormdata = pesFormState.setFormdata, handleMainSubmit = pesFormState.handleMainSubmit, handlePreSubmit = pesFormState.handlePreSubmit, headerName = pesFormState.headerName, isFormPesLoading = pesFormState.isFormPesLoading;
    usePesLoadingSync({
        loadingStates: [
            isInitPesLoading,
            isFormPesLoading
        ]
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page pes-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "การเงินและบัญชี"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "เชื่อมต่อ PEAK"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-24 mb-4",
                                children: headerName
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-[11px] h-[35px] p-[11px] rounded-[8px] pagezoom mb-4 bg-[#FFEBEB]",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        className: "aspect-square w-[14px]",
                                        src: "/images/icon-warn-red.png"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-14 font-semibold text-[#FF0000]",
                                        children: "สามารถใส่เอกสารสูงสุด 10 รายการ"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values, param) {
                    var resetForm = param.resetForm;
                    handleMainSubmit({
                        values: values,
                        resetForm: resetForm
                    });
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setErrors = param.setErrors;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handlePreSubmit({
                                productRow: productRow,
                                setFieldValue: setFieldValue,
                                handleSubmit: handleSubmit,
                                values: values,
                                attachments: attachments,
                                attachmentDeliver: attachmentDeliver,
                                tagselected: tagselected,
                                updateDocIds: updateDocIds,
                                setModalAlert: setModalAlert,
                                setErrors: setErrors
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    pesID && values.canceledPesEmp && /*#__PURE__*/ _jsxs("div", {
                                        className: "cancel-warn pagezoom mb-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/images/icon-warn-red.png"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16",
                                                children: "".concat(moment(values.canceled_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.canceledPesEmp), " “").concat(values.not_approve_reason, "”")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        style: {
                                            minWidth: "1000px"
                                        },
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card-body px-xl-3",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    id: "",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "pt-3 px-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row row gx-xl-4",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-12",
                                                                        children: pesID && values.dimMstPesStatus && /*#__PURE__*/ _jsx("div", {
                                                                            className: "d-flex justify-content-end align-items-center h-100",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx(PesDocStatus, {
                                                                                    statusID: values.dimMstPesStatus.id,
                                                                                    statusName: values.dimMstPesStatus.name
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-3",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "เลขที่เอกสาร",
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "doc_number",
                                                                                        className: "form-control",
                                                                                        placeholder: "",
                                                                                        value: values.doc_number,
                                                                                        onChange: handleChange,
                                                                                        disabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-3",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "ผู้ส่งเอกสาร",
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        className: "form-control",
                                                                                        placeholder: "ผู้ส่งเอกสาร",
                                                                                        value: getEmpFullNameTHByEmpData(values.lastestSyncEmp),
                                                                                        disabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: "btn btn-st-3 me-3",
                                            style: tab != 1 ? {
                                                background: "transparent",
                                                border: 0,
                                                color: "#9C9C9C"
                                            } : {},
                                            onClick: function() {
                                                return setTab(1);
                                            },
                                            children: "ข้อมูลเอกสาร"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        sumproductOrdered: sumproductOrdered,
                                        setSumproductOrdered: setSumproductOrdered,
                                        optionsMstVat: options.vat,
                                        optionNewItemCol: options.pesItemCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        filterDisplay: filterDisplay,
                                        setFilterDisplay: setFilterDisplay,
                                        pesID: pesID
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-20 fw-bold",
                                                                children: "สรุปข้อมูล"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "mt-[15px] fs-18",
                                                                children: [
                                                                    "จำนวนเอกสาร",
                                                                    " ",
                                                                    productRow.filter(function(v) {
                                                                        return v.docNumber;
                                                                    }).length,
                                                                    " รายการ"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductNoVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 0 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductZeroVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 7 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductSevenVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "ภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductPrice, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-auto",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white fs-24",
                                                                style: {
                                                                    background: "#FF6B00",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: NumberFormat(sumproductPrice, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagSelected, {
                                                                            tagselected: tagselected,
                                                                            setTagSelected: setTagSelected,
                                                                            formdisabled: formdisabled
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(PesFooterSubmit, {
                                setFieldValue: setFieldValue,
                                setModalNotApprove: setModalNotApprove,
                                setModalConfirmCancel: setModalConfirmCancel,
                                setModalDeliEndProcess: setModalDeliEndProcess,
                                setModalReadyToDeliProcess: setModalReadyToDeliProcess,
                                values: values,
                                productRow: productRow,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-5"
                            }),
                            /*#__PURE__*/ _jsx(PesModalGroup, {
                                setFieldValue: setFieldValue,
                                handleChange: handleChange,
                                values: values,
                                errors: errors,
                                modalConfirmCancel: modalConfirmCancel,
                                setModalConfirmCancel: setModalConfirmCancel,
                                modalSuccess: modalSuccess,
                                setModalSuccess: setModalSuccess,
                                modalSaveSuccess: modalSaveSuccess,
                                setModalSaveSuccess: setModalSaveSuccess,
                                modalDeliEndProcess: modalDeliEndProcess,
                                setModalDeliEndProcess: setModalDeliEndProcess,
                                modalNotApprove: modalNotApprove,
                                setModalNotApprove: setModalNotApprove,
                                modalAlert: modalAlert,
                                setModalAlert: setModalAlert,
                                attachments: attachmentDeliver,
                                setAttachments: setAttachmentDeliver,
                                handlePreviewFile: handlePreviewDeliverFile,
                                modalReadyToDeliProcess: modalReadyToDeliProcess,
                                setModalReadyToDeliProcess: setModalReadyToDeliProcess
                            })
                        ]
                    });
                }
            })
        ]
    });
}
function ProductData(param) {
    var values = param.values, setFieldValue = param.setFieldValue, optionsWarehouse = param.optionsWarehouse, optionNewItemCol = param.optionNewItemCol, productRow = param.productRow, setProductRow = param.setProductRow, setSumproductPrice = param.setSumproductPrice, setSumproductNoVat = param.setSumproductNoVat, setSumproductZeroVat = param.setSumproductZeroVat, setSumproductSevenVat = param.setSumproductSevenVat, setSumproductBeforeVat = param.setSumproductBeforeVat, sumproductOrdered = param.sumproductOrdered, columnsort = param.columnsort, setColumnsort = param.setColumnsort, formdisabled = param.formdisabled, filterDisplay = param.filterDisplay, setFilterDisplay = param.setFilterDisplay, pesID = param.pesID;
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    getDocTableRowPesInit()
                ]);
            });
        }
    };
    var setDocSeletecteds = usePesInitContext().setDocSeletecteds;
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(10);
        }
    }, []);
    useEffect(function() {
        if (values.is_one_receiving_point && productRow.length > 0) {
            setProductRow(function(prev) {
                return prev.map(function(pd) {
                    if (pd.productID) {
                        var warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        var warehouseName = warehouse ? warehouse.label : "";
                        return _object_spread_props(_object_spread({}, pd), {
                            warehouseID: warehouseID,
                            warehouseName: warehouseName
                        });
                    }
                    return _object_spread({}, pd);
                });
            });
        }
    }, [
        values.dim_warehouse_id
    ]);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductQty = _useState1[0], setSumproductQty = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumUms = _useState2[0], setSumUms = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductVat = _useState3[0], setSumProductVat = _useState3[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.docProductQty);
            var productPrice = parseFloat(pd.docIncVatPrice);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            if (hasValidQty && hasValidPrice) {
                price += pd.docIncVatPrice;
                priceBeforeVat += pd.docExVatPrice;
                priceNoVat += pd.docNoVatPrice;
                priceZeroVat += pd.docZeroVatPrice;
                priceSevenVat += pd.docSevenVatPrice;
                priceVat += pd.docVatPrice;
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
    };
    useEffect(function() {
        if (values.dim_mst_price_category_id == 3) {
            setProductRowVatByMstCategoryPrice(values.dim_mst_price_category_id, setProductRow);
        }
    }, [
        values.dim_mst_price_category_id
    ]);
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", productRow);
    // setProductRow(product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _usePesInitContext = usePesInitContext(), docLimit = _usePesInitContext.docLimit, pesProductDataInitState = _usePesInitContext.pesProductDataInitState;
    var modal = pesProductDataInitState.modal, setModal = pesProductDataInitState.setModal, modalSort = pesProductDataInitState.modalSort, setModalSort = pesProductDataInitState.setModalSort, documentType = pesProductDataInitState.documentType, modalSelectDocument = pesProductDataInitState.modalSelectDocument, setModalSelectDocument = pesProductDataInitState.setModalSelectDocument, columdisplay = pesProductDataInitState.columdisplay, setColumDisplay = pesProductDataInitState.setColumDisplay, modalDisplayFilter = pesProductDataInitState.modalDisplayFilter, setModalDisplayFilter = pesProductDataInitState.setModalDisplayFilter;
    useEffect(function() {
        var idisplay = localStorage.getItem("columdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState4 = _sliced_to_array(useState(false), 2), customSort = _useState4[0], setCustomSort = _useState4[1];
    var _useState5 = _sliced_to_array(useState(), 2), activeId = _useState5[0], setActiveId = _useState5[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(PesMultiSelectTable, {})
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "fact_item_pes_col_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayFilter,
                setModal: setModalDisplayFilter,
                htitle: "ตัวกรอง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableFilterDisplay, {
                    filterDisplay: filterDisplay,
                    filterdisplayName: "filterdisplay",
                    setModalDisplayFilter: setModalDisplayFilter,
                    setFilterDisplay: setFilterDisplay
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                removeCheckedProductsAndSyncSelections({
                                    productRow: productRow,
                                    setProductRow: setProductRow,
                                    setDocSeletecteds: setDocSeletecteds
                                });
                                addProductRow(checkLenght);
                            },
                            disabled: values.fact_new_so_id,
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : customSort ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "alert-w",
                            children: "กรุณาเลือกที่แถวเพื่อจัดลำดับ"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            className: "btn btn-st-x1 me-2",
                            children: "บันทึกการจัดเรียง"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            children: "ยกเลิกการจัดเรียง"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 flex",
                    children: [
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: formdisabled,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-x1 me-2",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: true
                                        });
                                    });
                                },
                                disabled: productRow.filter(function(v) {
                                    return v.docNumber;
                                }).length >= docLimit,
                                children: "เพิ่มเอกสาร"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalSort(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "จัดเรียง"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("fieldset", {
                disabled: formdisabled,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pagezoom",
                    style: {
                        overflowX: "auto",
                        maxWidth: "100%",
                        overflowY: "hidden",
                        paddingBottom: "20px"
                    },
                    children: /*#__PURE__*/ _jsxs(DndContext, {
                        sensors: sensors,
                        collisionDetection: closestCenter,
                        onDragEnd: handleDragEnd,
                        onDragCancel: handleDragCancel,
                        onDragStart: handleDragStart,
                        modifiers: [
                            restrictToVerticalAxis
                        ],
                        children: [
                            /*#__PURE__*/ _jsx(SortableContext, {
                                items: productRow,
                                strategy: verticalListSortingStrategy,
                                children: /*#__PURE__*/ _jsxs("table", {
                                    className: "column_resize_table table1 table-striped ",
                                    style: {
                                        width: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("thead", {
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "form-check form-check-st-t1",
                                                            children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                                className: "form-check-input",
                                                                type: "checkbox",
                                                                name: "",
                                                                onChange: function(e) {
                                                                    if (e.target.checked === true) {
                                                                        setProductRow(function(prev) {
                                                                            return prev.map(function(el) {
                                                                                return _object_spread_props(_object_spread({}, el), {
                                                                                    is_checked: true
                                                                                });
                                                                            });
                                                                        });
                                                                    } else {
                                                                        setProductRow(function(prev) {
                                                                            return prev.map(function(el) {
                                                                                return _object_spread_props(_object_spread({}, el), {
                                                                                    is_checked: false
                                                                                });
                                                                            });
                                                                        });
                                                                    }
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 35
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "เลขที่เอกสาร"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 200
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "เลขที่เชื่อมต่อ peak"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 200
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "เลขที่อ้างอิง"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 200
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "วันที่รับ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ผู้จัดจำหน่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 250
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "จำนวนสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "มูลค่าก่อนภาษี"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 150
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "มูลค่าภาษี"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 150
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "มูลค่าสุทธิ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "วันที่ตรวจสอบ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 120
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "หมายเหตุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 120
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: productRow.map(function(item, index) {
                                                return /*#__PURE__*/ _jsx(DocTableRow, {
                                                    item: item,
                                                    index: index,
                                                    setProductRow: setProductRow,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    rowCount: rowCount,
                                                    addProductRow: addProductRow,
                                                    filterDisplay: filterDisplay,
                                                    values: values,
                                                    pesID: pesID,
                                                    columnPresets: columnPresets.docStandard
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("tfoot", {
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "column_resizer_body"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "column_resizer_body"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "column_resizer_body"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "column_resizer_body"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "column_resizer_body"
                                                    }),
                                                    columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {}),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "column_resizer_body"
                                                            })
                                                        ]
                                                    }) : "",
                                                    columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {}),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "column_resizer_body"
                                                            })
                                                        ]
                                                    }) : "",
                                                    values.dimMstPesStatus && getDeliveredStatusList.includes(values.dimMstPesStatus.id) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                    value: sumproductOrdered,
                                                                    thousandSeparator: ",",
                                                                    decimalScale: 0,
                                                                    fixedDecimalScale: true,
                                                                    customInput: function(e) {
                                                                        return /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "",
                                                                            className: "form-control text-center",
                                                                            placeholder: "",
                                                                            value: e.value,
                                                                            disabled: true,
                                                                            style: {
                                                                                position: "absolute",
                                                                                right: "-0.5vw",
                                                                                top: "10px"
                                                                            }
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "column_resizer_body"
                                                            })
                                                        ]
                                                    }) : "",
                                                    columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                    value: sumUms,
                                                                    thousandSeparator: ",",
                                                                    decimalScale: 0,
                                                                    fixedDecimalScale: true,
                                                                    customInput: function(e) {
                                                                        return /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "",
                                                                            className: "form-control text-center",
                                                                            placeholder: "",
                                                                            value: e.value,
                                                                            disabled: true,
                                                                            style: {
                                                                                position: "absolute",
                                                                                right: "-0.5vw",
                                                                                top: "10px"
                                                                            }
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "column_resizer_body"
                                                            })
                                                        ]
                                                    }) : ""
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(DragOverlay, {
                                children: /*#__PURE__*/ _jsxs("table", {
                                    className: "column_resize_table table1 table-striped  table-thead-0",
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("thead", {
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                style: {
                                                    height: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 35
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 200
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 200
                                                    }),
                                                    columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {}),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer",
                                                                minWidth: 100
                                                            })
                                                        ]
                                                    }) : "",
                                                    columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {}),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer",
                                                                minWidth: 130
                                                            })
                                                        ]
                                                    }) : "",
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {
                                                                style: {
                                                                    backgroundColor: "#FF731D",
                                                                    color: "#FFF"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer bg-FF731D",
                                                                minWidth: 100
                                                            })
                                                        ]
                                                    }) : "",
                                                    columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {
                                                                style: {
                                                                    backgroundColor: "#3FA5FF",
                                                                    color: "#FFF"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer bg-3FA5FF",
                                                                "bg-FF731D": true,
                                                                minWidth: 100
                                                            })
                                                        ]
                                                    }) : "",
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 110
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 140
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 120
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 80
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    }),
                                                    columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {}),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer",
                                                                minWidth: 120
                                                            })
                                                        ]
                                                    }) : "",
                                                    columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {}),
                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                className: "columnResizer",
                                                                minWidth: 100
                                                            })
                                                        ]
                                                    }) : "",
                                                    /*#__PURE__*/ _jsx("th", {}),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 100
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: /*#__PURE__*/ _jsx(Productrow, {
                                                item: selectedRow ? selectedRow[0] : "",
                                                index: 0,
                                                setProductRow: setProductRow,
                                                columdisplay: columdisplay,
                                                customSort: customSort,
                                                values: values
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
